/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAvatar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0 2h16v16h-2.07c-.159-1.111-.591-2.203-1.362-3.092C15.546 15.728 14.01 15 12 15s-3.547.729-4.568 1.908c-.77.889-1.203 1.98-1.362 3.092H4V4zm4.099 16c.138-.678.421-1.295.844-1.783C9.547 17.521 10.51 17 12 17s2.454.521 3.057 1.217c.422.488.705 1.105.844 1.783H8.099zM12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAvatar as Avatar };
